//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      records: [{
        createTimeStr: '03-01 11:37',
        goodsName: 'Häagen-Dazs™ $50 Gift Voucher',
        integral: -5000
      }, {
        createTimeStr: '01-22 15:26',
        goodsName: 'Huawei Nova 3',
        integral: -300000
      }, {
        createTimeStr: '01-22 15:25',
        goodsName: 'MyLink Special Octopus with stored value $15',
        integral: -300000
      }]
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/demo/tableDemo.vue